/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const initialState = { };

const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    setUser(state, action) {
      state.user = action.payload;
    },
    setAccount(state, action) {
      state.account = action.payload;
    },
    setAccounts(state, action) {
      state.accounts = action.payload || [];
    },
    setMemberRole(state, action) {
      state.memberRole = action.payload;
    },
  },
});

export default accountSlice.reducer;

export const {
  setUser, setAccount, setAccounts, setMemberRole,
} = accountSlice.actions;

export const isAuthenticated = (state) => !!state.account.user;
